import { Component, Inject, OnInit } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { MatProgressBar } from '@angular/material/progress-bar'
import { MatIcon } from '@angular/material/icon'
import { MatButton } from '@angular/material/button'
import { TableListComponent } from '../../../shared/components/table-list/table-list.component'
import { PassageiroItemContratoService } from '../../../core/services/passageiro-item-contrato/passageiro-item-contrato.service'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'

@Component({
  selector: 'logistics-validation-modal',
  standalone: true,
  imports: [MatProgressBar, MatIcon, MatButton, TableListComponent],
  templateUrl: './logistics-validation-modal.component.html',
  styleUrl: './logistics-validation-modal.component.scss',
})
export class LogisticsValidationModalComponent implements OnInit {
  constructor(
    private dialogRef: MatDialogRef<LogisticsValidationModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private passageiroItemContratoService: PassageiroItemContratoService,
    private snackbar: SnackbarCustomService,
  ) {}

  loading = false
  validacao: {
    discrepanciasQuantidade: any[]
    discrepanciasTrecho: any[]
    discrepanciasRota: any[]
    compativel: boolean
  } | null = null
  validacaoError = false

  quantidadeColumns: any[] = []

  trechoColumns = [
    { keyColumn: 'nome', key: 'nome', description: 'Passageiro' },
    { keyColumn: 'servicoDescricao', key: 'servicoDescricao', description: 'Serviço' },
    { keyColumn: 'dataInicio', key: 'dataInicio', description: 'Data Início' },
    { keyColumn: 'tipoTrechoPassageiro', key: 'tipoTrechoPassageiro', description: 'Trecho do Passageiro' },
    { keyColumn: 'tipoTrechoItem', key: 'tipoTrechoItem', description: 'Trecho do Item' },
  ]

  rotaColumns = [
    { keyColumn: 'servicoDescricao', key: 'servicoDescricao', description: 'Serviço' },
    { keyColumn: 'dataInicio', key: 'dataInicio', description: 'Data Início' },
    { keyColumn: 'tipoTrechoItem', key: 'tipoTrechoItem', description: 'Trecho do Item' },
    { keyColumn: 'veiculoOrigem', key: 'veiculoOrigem', description: 'Origem' },
    { keyColumn: 'veiculoDestino', key: 'veiculoDestino', description: 'Destino' },
    { keyColumn: 'totalPassageiros', key: 'totalPassageiros', description: 'Total Passageiros' },
    { keyColumn: 'passageirosIncompativeis', key: 'passageirosIncompativeis', description: 'Passageiros Incompatíveis' },
    { keyColumn: 'exemploRotaPassageiro', key: 'exemploRotaPassageiro', description: 'Exemplo de Rota do Passageiro' },
  ]

  ngOnInit() {
    this.load()
  }

  load() {
    this.loading = true
    this.validacaoError = false
    this.passageiroItemContratoService.getValidacaoLogistica(this.data.id).subscribe({
      next: (res: any) => {
        this.validacao = res.data ?? res ?? null
        this.quantidadeColumns = this.validacao?.discrepanciasQuantidade?.length
          ? Object.keys(this.validacao.discrepanciasQuantidade[0]).map((key) => ({
              keyColumn: key,
              key,
              description: this.humanizeKey(key),
            }))
          : []
      },
      error: () => {
        this.snackbar.error('Não foi possível carregar a validação logística.')
        this.validacaoError = true
        this.loading = false
      },
      complete: () => {
        this.loading = false
      },
    })
  }

  private humanizeKey(key: string): string {
    const withSpaces = key.replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    return withSpaces.charAt(0).toUpperCase() + withSpaces.slice(1)
  }

  close() {
    this.dialogRef.close()
  }
}
